import React, { useState, useEffect } from "react"

import "./section-redeem-info.scss"
import Button from "../../../shared/components/atoms/button/button"
import BackButton from "../../../shared/components/atoms/back-button/back-button"
import StepsRedeemItem from "../../atoms/steps-redeem-item/steps-redeem-item"
import WhatsappRedeemLink from "../../atoms/whatsapp-redeem-link/whatsapp-redeem-link"
import { getTextFourContests, getTextFourRedeemInfo, getTextOneContests, getTextOneRedeemInfo, getTextThreeContests, getTextTwoContests, getTextTwoRedeemInfo } from "../../../utils/getPointMessages"
import { withBottomLine } from "../../../shared/utils/formatString"
import { buttonClickTransversal } from "../../../utils/loyaltyDatalayer"
import StepThreeYourCart from "../step-three-your-cart/step-three-your-cart"

const SectionRedeemInfo = props => {
  const { mobile, setIsRedeemInfo, isLogin, category = "mis_puntos" } = props
  const isColombia = process.env.LOCALE === "es-CO"

  const EC_proceduresVirtual = (
    <p className="f-steps-item-info-description">
      Una vez realizado tu canje la información será enviada a nuestro proveedor
      logístico, el mismo que se pondrá en contacto contigo para coordinar la
      entrega de tu canje y la recolección de los empaques correspondientes a tu
      canje. <br />  <br /> Por favor te pedimos estar atenta los días siguientes a tu canje a
      las llamadas de números desconocidos ya que existirán 3 oportunidades de
      contacto y si no logramos contactarnos contigo en esas 3 ocasiones
      cerraremos tu canje y no existirá devolución de puntos ni entrega de algún
      otro premio.<br />  <br />  El proceso con el gestor logístico puede tardar hasta 20 días
      hábiles. Si tienes alguna inquietud acerca de este proceso por favor no
      dudes en comunicarte a nuestra línea de atención en Whatspp estará
      disponible de Lunes a Viernes 9h00 a 18h00 No aplica en los días feriados.
      Recuerda que esta línea solo será para inquietudes, dudas o problemas con
      tu canje. <br />  <br />  * Los premios están sujetos a disponibilidad, nuestra asesora te
      dirá si lo están o no al momento de comunicarte.
    </p>
  )

  const CO_proceduresVirtual = (
    <p className="f-steps-item-info-description">
      Envía una imagen de cada empaque por separado y el formulario siguiendo
      estos pasos:
      <br />
      <br />
      <span className="f-font">Escribe:</span> a la línea para atención de
      whatsapp <WhatsappRedeemLink /> que hemos autorizado y sigue las
      instrucciones que la asesora te dará, <b>¡súper importante!</b>{" "}
      {process.env.LOCALE === "es-EC" ? (
        <>
          Es necesario que envíes las fotos de tus empaques de la siguiente
          manera: una foto de la parte frontal del empaque donde deberás colocar
          con un marcador permanente{" "}
          <b>los últimos 4 dígitos del código del pedido </b>
          que podrás encontrar en el formulario que acabaste de redimir, otra
          foto de la <b>clave personal</b> del empaque y otra de los puntos.
        </>
      ) : (
        <>
          Que envíes la foto de cada empaque por separado de esta manera: en el
          frente con un marcador permanente pongas{" "}
          <b>los últimos 4 dígitos del código del pedido</b> del formulario que
          acabaste de redimir, otra foto de la <b>clave personal</b> y otra de
          los puntos.
        </>
      )}
      <br />
      <br />
      Después de haber terminado todo el proceso por esta línea, el envío de tus
      premios puede tardar hasta <b>20 días hábiles</b>.
      <br />
      <br />
      La línea de <b>Whatsapp</b> estará disponible de{" "}
      <b>
        {process.env.LOCALE === "es-EC"
          ? "Lunes a Viernes de 8:30 a.m a 01:00 p.m y de 02:00 p.m a 05:30 p.m"
          : "Lunes a Viernes de 8:00 a.m a 12:00 p.m y de 01:00 p.m a 06:00 p.m"}
      </b>{" "}
      No aplica en los días{" "}
      {process.env.LOCALE === "es-EC" ? "feriados" : "festivos"}. Recuerda que
      esta línea solo será para el envío de tus empaques y tu formulario.
      <br />
      <br />
      Te invitamos a que guardes tus empaques pues pronto habilitaremos los
      puntos de entrega para que los devuelvas, le hagamos bien al planeta y
      sigamos apoyando la economía circular.
      <br />
      <br />
      <b>
        {" "}
        * Los premios están sujetos a disponibilidad, nuestra asesora te dirá si
        lo están o no al momento de comunicarte.
      </b>
    </p>
  )

  const physicalPrizes = [
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextOneRedeemInfo(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-CL"
          ? require("../../../assets/images/new-icons/1.png")
          : process.env.LOCALE === "es-AR"
         ? require("../../../assets/images/physicalPrizesAr1.png")
         : require("../../../assets/images/clave@2xl.png")


        :process.env.LOCALE === "es-CL"
        ? require("../../../assets/images/new-icons/1.png")
        :process.env.LOCALE === "es-AR"
          ? require("../../../assets/images/physicalPrizesAr1.png") 
          : require("../../../assets/images/clave@2x.png")

 
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextTwoRedeemInfo(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-PE"
          ? require("../../../assets/images/redime-tus-puntos-1.png")
          : process.env.LOCALE === "es-PR"
          ? require("../../../assets/images/redime-tus-puntos-1.png")
          : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
          ? require("../../../assets/images/correo@2xl.png")
          : process.env.LOCALE === "es-CL"
          ? require("../../../assets/images//new-icons/2.png")
          : process.env.LOCALE === "es-AR"
          ? require("../../../assets/images/physicalPrizesAr2.png")
          : require("../../../assets/images/productos@2xl.png")
        : process.env.LOCALE === "es-PE"
        ? require("../../../assets/images/redime-tus-puntos-1.png")
        : process.env.LOCALE === "es-PR"
        ? require("../../../assets/images/redime-tus-puntos-1.png")
        : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/correo@2x.png")
        : process.env.LOCALE === "es-CL"
        ? require("../../../assets/images//new-icons/2.png")
        : process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/physicalPrizesAr2.png")
        : require("../../../assets/images/productos@2x.png"),
    },
    {
      description:
        process.env.LOCALE === "es-CO" ? (
          CO_proceduresVirtual
        ) : process.env.LOCALE === "es-EC" ? (
          EC_proceduresVirtual
        ) : process.env.LOCALE === "es-PE" ? (
          <p className="f-steps-item-info-description">
            Envía las imágenes de tus empaques y formulario siguiendo estos
            pasos:
            <br />
            <br />
            <span className="f-font">Correspondencia:</span> Envía por
            correspondencia el formulario junto con los empaques completos de
            tus productos Nosotras a la siguiente dirección: Tiendas Nosotras.
            Destinatario: Tienda Nosotras. Dirección en Quito: Tadeo Benítez
            Oe1-807 y Joaquín Mancheno. Dirección en Guayaquil: Av. De las
            Américas y Eleodoro Arboleda Edificio Mecanos 3er Piso, oficina 304.
            Una vez verifiquemos que tus datos personales estén completos y que
            los puntos correspondan al premio que elegiste lo enviaremos a la
            dirección colocada en el formulario.
            <br />
            <br />
            Recuerda que el envío de tus premios puede tardar hasta 20 días
            hábiles después de que hayamos recibido los empaques en la bodega de
            nuestro proveedor logístico.
            <br />
            <br />
            <span className="f-font"> Famitiendas</span> Imprime el formulario
            con tus datos personales y trae contigo los empaques. ¡Deberás
            entregar todo junto en la Famitienda más cercana!
            <br />
            <br />
            <b>Famitienda Quito:</b> Tadeo Benítez Oe1-807 y Joaquín Mancheno.
            Famitienda Guayaquil: Av. De las Américas y Eleodoro Arboleda
            Edificio Mecanos 3er Piso, oficina 304.
            <br />
            <br />
            Si llegas a la Famitienda y tu premio ya no está disponible, debes
            elegir otro que sí esté y que cumpla con el número de puntos que
            cuesta el que habías seleccionado anteriormente.
            <br />
            <br />
            <b>
              {" "}
              * Los premios están sujetos a disponibilidad. Si cuando lleguen
              tus empaques a nuestro proveedor logístico tu premio no está
              disponible, nos comunicaremos contigo para cambiar tu premio o
              devolverte tus puntos
            </b>
          </p>
        ): process.env.LOCALE === "es-AR" ?
          (<p className="f-steps-item-info-description">Canjeá los puntos por el premio y completá el formulario con tus datos personales. Tené en cuenta que con esta información enviaremos tu premio, así que debés estar segura de que estén correctos. Los premios serán enviados mediante correo con lo cual se hará el intento de entregarlo la cantidad de veces que el correo tenga predeterminado, pero si los datos son incorrectos, el premio no se volverá a enviar.</p>)
        : process.env.LOCALE === "es-CL" ? 
          (<p className="f-steps-item-info-description">Canjea los puntos por el premio y completa el formulario con tus datos personales. Ten en cuenta que con esta información enviaremos tu premio, así que debes estar segura de que estén correctos. Los premios serán enviados mediante correo con lo cual se hará el intento de entregarlo la cantidad de veces que el correo tenga predeterminado, pero si los datos son incorrectos, el premio no se volverá a enviar.</p>)
        : (
          <p className="f-steps-item-info-description">
            Lleva tus empaques y tu formulario, tienes dos opciones:
            <br />
            <br />
            <span className="f-font">Servientrega:</span> Marca el sobre en el
            que llevarás tus empaques con: nombre,{" "}
            {process.env.LOCALE === "es-PR" ? "municipio" : "ciudad"},
            dirección, teléfono y un texto que diga “Programa Puntos Nosotras” y
            adjunta uno de los formularios. Llévalo a un punto de Servientrega
            autorizado y el otro formulario debes mostrárselo a la persona que
            recibe tu sobre, para que le ponga el sello de recibido y
            consérvalo, éste te servirá como prueba de la entrega de los
            empaques. Conoce los puntos de Servientrega autorizados{" "}
            <a
              href="https://assets.ctfassets.net/o65uf8qogksw/1gh2zvsYW5rnebXAO0eV9q/358aa8ed580e21735638eb14455239bc/Puntos_autorizados_Servientrega_-_INFORME_DIRECTORIO_CDS.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              aquí.
            </a>
            <br />
            <br />
            Recuerda que el envío de tus premios puede tardar hasta 20 días
            hábiles después de que hayamos recibido los empaques en la bodega de
            nuestro proveedor logístico.
            <br />
            <br />
            Si estás en Medellín, visita la{" "}
            <span className="f-font"> Famitienda</span> más cercana, lleva solo
            un formulario impreso junto con tus empaques.
            <br />
            <br />
            <b>Pier 30:</b> Lunes a viernes de 8:00 a.m.a 7:00 p.m.y los sábados
            de 8:00 a.m.a 4:00 p.m.
            <br />
            <br />
            <b>Oriental:</b> Lunes a viernes de 10:00 a.m.a 6:00 p.m.y los
            sábados de 8:00 a.m.a 4:00 p.m.
            <br />
            <br />
            Si llegas a la Famitienda y tu premio ya no está disponible, debes
            elegir otro que sí lo esté y que cumpla con el número de puntos que
            cuesta el que habías seleccionado anteriormente.
            <br />
            <br />
            <b>
              {" "}
              * Los premios están sujetos a disponibilidad. Si cuando lleguen
              tus empaques a nuestro proveedor logístico tu premio no está
              disponible, nos comunicaremos contigo para cambiar tu premio o
              devolverte tus puntos
            </b>
          </p>
        ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-PE"
          ? require("../../../assets/images/famitienda-PE.png")
          : process.env.LOCALE === "es-EC"
            ? require("../../../assets/images/logistico-EC-log.png")
          : process.env.LOCALE === "es-CO"
          ? require("../../../assets/images/whatsapp-rosa.png")
          : process.env.LOCALE === "es-CL"
          ? require("../../../assets/images/new-icons/3.png")
          : process.env.LOCALE === "es-AR"
          ? require("../../../assets/images/physicalPrizesAr3.png")
          : require("../../../assets/images/contests-mail-log.png")
        : process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/logistico-EC.png")
        : process.env.LOCALE === "es-PE"
        ? require("../../../assets/images/famitienda-2-PE.png")
        : process.env.LOCALE === "es-CO"
        ? require("../../../assets/images/whatsapp-blanco.png")
        : process.env.LOCALE === "es-CL"
        ? require("../../../assets/images/new-icons/3.png")
        : process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/physicalPrizesAr3.png")
        : require("../../../assets/images/contests-mail.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextFourRedeemInfo(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
        ? isColombia
          ? require("../../../assets/images/new-icons/2.png")
          : process.env.LOCALE === "es-PE" || process.env.LOCALE === "es-EC"
          ? require("../../../assets/images/premios-1-EC.png")
          : process.env.LOCALE === "es-CL"
          ? require("../../../assets/images/logistico-EC.png")
          : process.env.LOCALE === "es-AR"
          ? require("../../../assets/images/physicalPrizesAr4.png")
          : require("../../../assets/images/premios@2xl.png")
        : isColombia
        ? require("../../../assets/images/new-icons/2.png")
        : process.env.LOCALE === "es-PE" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/premios-2-EC.png")
        : process.env.LOCALE === "es-CL"
        ? require("../../../assets/images/logistico-EC.png")
        : process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/physicalPrizesAr4.png")
        : require("../../../assets/images/premios@2x.png"),
    },
    {
      description: (
      process.env.LOCALE === "es-AR" ?
        <p className="f-steps-item-info-description">
          Podés contactarte a la línea para atención al cliente 0800-333-2147 si tenés dudas o consultas.
        </p>
      : process.env.LOCALE === "es-CL" ?
        <p className="f-steps-item-info-description">
        Puedes contactarte con Nosotras a través de nuestras Redes Sociales como @nosotraschile o a través del correo contactonosotraschile@essity.com
        </p>
      : ''
      ),
      imgUrl: 
        process.env.LOCALE === "es-AR" ?
        require("../../../assets/images/physicalPrizesAr5.png")
        : process.env.LOCALE === "es-CL" &&
        require("../../../assets/images/new-icons/5.png")
    },
  ]

  const virtualPrizes = [
    {
      description: (
        process.env.LOCALE === "es-CL" ?
        <p className="f-steps-item-info-description">
        Selecciona el premio que quieres y canjea los puntos que necesitas. Si no te alcanzan, ingresa más claves personales o interactúa en NosotrasOnline hasta que llegues al valor necesario.
        </p>
        :
        <p className="f-steps-item-info-description">
          Selecciona el premio que quieres y redime los puntos que necesitas. Si
          no te alcanzan, ingresa más claves personales o interactúa en
          NosotrasOnline hasta que llegues al valor necesario.
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-CL" 
        ? require("../../../assets/images/new-icons/2.png")
        : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/clave@2x.png")
        : require("../../../assets/images/clave@2x.png")
      : process.env.LOCALE === "es-CL" 
      ? require("../../../assets/images/new-icons/2.png")
      : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
      ? require("../../../assets/images/clave@2x.png")
      : require("../../../assets/images/clave@2x.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          Diligencia el formulario con tus datos personales, asegúrate que estén
          correctos porque con esta información enviaremos tu premio.
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-CL" 
          ? require("../../../assets/images/new-icons/2-2.png")
          : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
          ? require("../../../assets/images/correo@2xl.png")
          : require("../../../assets/images/productos@2xl.png")
        : process.env.LOCALE === "es-CL" 
        ? require("../../../assets/images/new-icons/2-2.png")
        : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/correo@2x.png")
        : require("../../../assets/images/productos@2x.png"),
    },
    {
      description:
        process.env.LOCALE === "es-CL" ? (
          <p className="f-steps-item-info-description">
          Canjea los puntos por el premio y completa el formulario con tus datos personales. Ten en cuenta que con esta información enviaremos tu premio, así que debes estar segura de que estén correctos. Los premios serán enviados mediante correo con lo cual se hará el intento de entregarlo la cantidad de veces que el correo tenga predeterminado, pero si los datos son incorrectos, el premio no se volverá a enviar.
        </p>
        ):
        process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC" ? (
          CO_proceduresVirtual
        ) : (
          <p className="f-steps-item-info-description">
            Lleva tus empaques y tu formulario, tienes dos opciones:
            <br />
            <br />
            <span className="f-font">Servientrega:</span> Marca el sobre en el
            que llevarás tus empaques con: nombre,{" "}
            {process.env.LOCALE === "es-PR" ? "municipio" : "ciudad"},
            dirección, teléfono y un texto que diga “Programa Puntos Nosotras” y
            adjunta uno de los formularios. Llévalo a un punto de Servientrega
            autorizado y el otro formulario debes mostrárselo a la persona que
            recibe tu sobre, para que le ponga el sello de recibido y
            consérvalo, éste te servirá como prueba de la entrega de los
            empaques. Conoce los puntos de Servientrega autorizados{" "}
            <a
              href="https://assets.ctfassets.net/o65uf8qogksw/1gh2zvsYW5rnebXAO0eV9q/358aa8ed580e21735638eb14455239bc/Puntos_autorizados_Servientrega_-_INFORME_DIRECTORIO_CDS.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              aquí.
            </a>
            <br />
            <br />
            Recuerda que el envío de tus premios puede tardar hasta 20 días
            hábiles después de que hayamos recibido los empaques en la bodega de
            nuestro proveedor logístico.
            <br />
            <br />
            Si estás en Medellín, visita la{" "}
            <span className="f-font"> Famitienda</span> más cercana, lleva solo
            un formulario impreso junto con tus empaques.
            <br />
            <br />
            <b>Pier 30:</b> Lunes a viernes de 8:00 a.m.a 7:00 p.m.y los sábados
            de 8:00 a.m.a 4:00 p.m.
            <br />
            <br />
            <b>Oriental:</b> Lunes a viernes de 10:00 a.m.a 6:00 p.m.y los
            sábados de 8:00 a.m.a 4:00 p.m.
          </p>
        ),
      imgUrl: isLogin
          ? process.env.LOCALE === "es-CL" 
          ? require("../../../assets/images/new-icons/3.png")
          : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
          ? require("../../../assets/images/whatsapp-rosa.png")
          : require("../../../assets/images/correo@2xl.png")
        : process.env.LOCALE === "es-CL" 
        ? require("../../../assets/images/new-icons/3.png")
        : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/whatsapp-blanco.png")
        : require("../../../assets/images/correo@2x.png"),
    },
    {
      description: (
        process.env.LOCALE === "es-CL" ? 
          <p className="f-steps-item-info-description">
           Recuerda guardar tu formulario de canje y estar atenta a las llamadas de nuestro proveedor logístico para coordinar la entrega de tu premio
          </p>
        : 
          <p className="f-steps-item-info-description">
          Cuando nuestro proveedor logístico haya verificado tus empaques,
          recibirás un correo electrónico con toda la información para activar
          tu premio virtual.
        </p>
        ),
      imgUrl: isLogin
      ? process.env.LOCALE === "es-CL" 
      ? require("../../../assets/images/logistico-EC.png")
      : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
      ? require("../../../assets/images/logos@2xl.png")
      : require("../../../assets/images/logos@2xl.png")
    : process.env.LOCALE === "es-CL" 
    ? require("../../../assets/images/logistico-EC.png")
    : process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-EC"
    ? require("../../../assets/images/logos@2xl.png")
    : require("../../../assets/images/logos@2xl.png"),
    },
    {
      description: (
      process.env.LOCALE === "es-CL" &&
      <p className="f-steps-item-info-description">
      Puedes contactarte con Nosotras a través de nuestras Redes Sociales como @nosotraschile o a través del correo contactonosotraschile@essity.com
      </p>
    ),
    imgUrl: 
      process.env.LOCALE === "es-CL" && require("../../../assets/images/new-icons/5.png")
    },
  ]

  const contests = [
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextOneContests(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
      ? process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/contestsImage1.png")
        : require("../../../assets/images/clave@2xl.png")
      : process.env.LOCALE === "es-CL"
      ? require("../../../assets/images/new-icons/1-3.png")
      :process.env.LOCALE === "es-AR"
       ? require("../../../assets/images/contestsImage1.png") 
       :require("../../../assets/images/clave@2x.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextTwoContests(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
      ? process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/contestsImage2.png")
        : require("../../../assets/images/ganadoras@2xl.png")
      : process.env.LOCALE === "es-CL"
      ? require("../../../assets/images/new-icons/3.png")

     :process.env.LOCALE === "es-AR"
       ? require("../../../assets/images/contestsImage2.png") 
       :require("../../../assets/images/ganadoras@2x.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          {getTextThreeContests(process.env.LOCALE)}
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-PE"
          ? require("../../../assets/images/famitienda-EC.png")
          : process.env.LOCALE === "es-EC"
            ? require("../../../assets/images/logistico-EC-log.png")
          : process.env.LOCALE === "es-PR" ||
            process.env.LOCALE === "es-PY" ||
            process.env.LOCALE === "es-UY"
          ? require("./../../../assets/images/contests-mail-log.png")
          : process.env.LOCALE === "es-CL"
          ? require("../../../assets/images/new-icons/2-2.png")
          :process.env.LOCALE === "es-AR"
          ? require("../../../assets/images/contestsImage3.png") 
          : require("../../../assets/images/logos@2xl.png")
        : process.env.LOCALE === "es-PE"
        ? require("../../../assets/images/famitienda-2-EC.png")
          : process.env.LOCALE === "es-EC"
            ? require("../../../assets/images/logistico-EC.png")
        : process.env.LOCALE === "es-PR" ||
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-UY"
        ? require("./../../../assets/images/contests-mail.png")
        : process.env.LOCALE === "es-CL"
        ? require("../../../assets/images/new-icons/2-2.png")
        :process.env.LOCALE === "es-AR"
        ? require("../../../assets/images/contestsImage3.png") 
        : require("../../../assets/images/logos@2x.png"),
    },
    {
      description: (
        process.env.LOCALE !== "es-AR" && process.env.LOCALE !== "es-CL" ?
          <p className="f-steps-item-info-description">
            {getTextFourContests(process.env.LOCALE)}
          </p>
        : ""
      ),
      imgUrl: isLogin
        ? require("../../../assets/images/premios@2xl.png")
        : require("../../../assets/images/premios@2x.png"),
    },
  ]

  const contestsPY = [
    {
      description: (
        <p className="f-steps-item-info-description">
          Selecciona la actividad en la que quieres participar. Inicia sesión y
          redime los puntos que necesitas.
        </p>
      ),
      imgUrl: isLogin
        ? require("../../../assets/images/clave@2xl.png")
        : require("../../../assets/images/clave@2x.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          Debes guardar los empaques de las claves personales que ingresaste
          para participar, en caso de ser una ganadora debes entregarlos.
          Nosotras se pondrá en contacto contigo para organizar este envío. Por
          los puntos que utilices que son regalo de la marca no debes presentar
          empaques.
        </p>
      ),
      imgUrl: isLogin
        ? require("../../../assets/images/ganadoras@2xl.png")
        : require("../../../assets/images/ganadoras@2x.png"),
    },
    {
      description: (
        <p className="f-steps-item-info-description">
          Cuando verifiquemos tus empaques, ¡te contactaremos para que puedas
          retirar tus premios!
        </p>
      ),
      imgUrl: isLogin
        ? process.env.LOCALE === "es-PE" || process.env.LOCALE === "es-EC"
          ? require("../../../assets/images/famitienda-EC.png")
          : process.env.LOCALE === "es-PR" ||
            process.env.LOCALE === "es-PY" ||
            process.env.LOCALE === "es-UY"
          ? require("./../../../assets/images/contests-mail-log.png")
          : require("../../../assets/images/logos@2xl.png")
        : process.env.LOCALE === "es-PE" || process.env.LOCALE === "es-EC"
        ? require("../../../assets/images/famitienda-2-EC.png")
        : process.env.LOCALE === "es-PR" ||
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-UY"
        ? require("./../../../assets/images/contests-mail.png")
        : require("../../../assets/images/logos@2x.png"),
    },
  ]

  const [isLogIn, setIsLogIn] = useState(false)
  const [items, setItems] = useState(
    process.env.LOCALE === "es-PR"
      ? contests
      : process.env.LOCALE === "es-PY"
      ? contestsPY
      : physicalPrizes
  )
  const [buttonActive, setButtonActive] = useState(
    process.env.LOCALE === "es-PR" ? "contests" : "physicalPrizes"
  )

  const handleBack = e => {
    e.preventDefault()
    setIsRedeemInfo(false)
  }

  useEffect(() => {
    if (!mobile) {
      window.scrollTo(0, 530)
      if (localStorage.getItem("TOKEN_INFO")) setIsLogIn(true)
    } else {
      window.scrollTo(0, 730)
      if (localStorage.getItem("TOKEN_INFO")) setIsLogIn(true)
    }
  }, [])

  return (
    <div
      className={
        !isLogIn
          ? "f-section-redeem-info-container"
          : "f-section-redeem-info-container-login"
      }
    >
      {!isLogIn && (
        <span className="f-curve-effect-redeem-info">
          <span className="f-circle-redeem-info" />
        </span>
      )}

      <div id="qweqwe" className="f-section-redeem-info-container-wrap">
        <BackButton title={"VOLVER"} onClick={handleBack} />
        <div className="f-section-redeem-info-container-wrap-title">
          <h2>Aprende cómo usar tus puntos</h2>
        </div>
        <div
          className={
            "f-section-redeem-info-container-wrap-tabs" +
            (mobile ? " f-animation-tabs" : "")
          }
        >
          {process.env.LOCALE !== "es-PR" && process.env.LOCALE !== "es-PY" && (
            <Button
              className={
                (buttonActive === "physicalPrizes"
                  ? "primary-pink"
                  : "fourth-pink") + " small"
              }
              title="Premios físicos"
              onClick={() => {
                buttonClickTransversal({
                  category: withBottomLine(category),
                  label: "Premios físicos",
              });                        
                setItems(physicalPrizes)
                setButtonActive("physicalPrizes")
              }}
            />
          )}
          {["es-PE","es-EC","es-PR","es-AR","es-PY"].indexOf(process.env.LOCALE) === -1 && 
          (
              <Button
                className={
                  (buttonActive === "virtualPrizes"
                    ? "primary-pink"
                    : "fourth-pink") + " small"
                }
                title="Premios virtuales"
                onClick={() => {
                  buttonClickTransversal({
                    category: withBottomLine(category),
                    label: "Premios virtuales",
                  });
                  setItems(virtualPrizes)
                  setButtonActive("virtualPrizes")
                }}
              />
            )}
            {
              ["es-CL"].indexOf(process.env.LOCALE) === -1 && 
              (
                <Button
                className={
                  (buttonActive === "contests" ? "primary-pink" : "fourth-pink") +
                  " small"
                }
                title="Concursos"
                onClick={() => {
                  buttonClickTransversal({
                    category: withBottomLine(category),
                    label: "Concursos",
                  });
                  setItems(process.env.LOCALE === "es-PY" ? contestsPY : contests)
                  setButtonActive("contests")
                }}
              />
              )
            }
        </div>
        <div className="f-section-redeem-info-container-wrap-items">
          {items &&
            items.map((item, index) => (
              item.description !== "" && 
              <StepsRedeemItem
                key={index}
                index={index + 1}
                imgUrl={item.imgUrl}
                description={item.description}
              />
            ))}
        </div>
      </div>
    </div>
  )
}

export default SectionRedeemInfo
